import { render, staticRenderFns } from "./Foreword.vue?vue&type=template&id=d52b8b42&lang=html&"
import script from "./Foreword.vue?vue&type=script&lang=js&"
export * from "./Foreword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports